<template>
  <div>
    <div class="main">
      <div class="form-row-parse">
        <div class="form-input-parse">
          <label for="json-input">JSON Yandex</label>
          <input id="json-input" type="text" v-model="jsonIn" />
        </div>
        <div class="form-button-parse">
          <button @click="clear" class="clear">Очистить</button>
          <button @click="parse" class="parse">Парсить</button>
        </div>
        <div class="form-input-parse">
          <label for="user-input">Управляющая компания</label>
          <select id="user-input" v-model="villageData.user">
            <option v-for="(user, key) in users" :value="user.ID" :key="key">
              {{ user.FIO }}
            </option>
          </select>
        </div>
        <div class="form-button-parse">
          <router-link class="clear" to="/admin/map/addvillage/3">
            <span>Пропустить</span>
          </router-link>
        </div>
        <div class="form-button-parse">
          <router-link class="clear" to="/admin/map/addvillage/2_2">
            <span>Создать границы</span>
          </router-link>
        </div>
      </div>
      <div class="form-row-parse">
        <div class="form-input-parse" v-show="villageData.village">
          <label for="name-input">Название</label>
          <input id="name-input" type="text" v-model="villageData.village" />
        </div>
        <div class="form-input-parse" v-show="villageData.district">
          <label for="district-input">Район</label>
          <input
            id="district-input"
            type="text"
            v-model="villageData.district"
          />
        </div>
        <div class="form-input-parse" v-show="villageData.region">
          <label for="region-input">Регион</label>
          <input id="region-input" type="text" v-model="villageData.region" />
        </div>
        <div class="form-button-parse">
          <button @click="add" v-show="villageData.village" class="add">
            Добавить
          </button>
        </div>
        <div class="form-button-parse" v-show="info">
          {{ info }}
          <router-link
            class="clear"
            :to="'/admin/map/addvillage/3?village_id=' + newVillageId"
          >
            <span>Продолжить</span>
          </router-link>
        </div>
      </div>
    </div>
    <div>
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom="12"
        :controls="[]"
      >
        <ymap-marker
          v-for="(item, index) in villageData.geometries"
          :coords="item.coordinates"
          :marker-type="item.type"
          :marker-fill="{ color: '#307c0d', opacity: 0.5 }"
          :options="overlayEditMapOptions"
          :marker-id="index + 1"
          v-bind:key="index + 1"
        />
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  name: "AddVillageCoord",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      info: null,
      jsonIn: null,
      users: [],
      villageData: {
        user: null,
        country: null,
        region: null,
        district: null,
        village: null,
        geometries: []
      },
      newVillageId: false,
      url: config.backend_url,
      coords: [55.755819, 37.617644],
      coordsCenter: [55.755819, 37.617644],
      overlayEditMapOptions: {
        fillColor: "#307c0d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      }
    };
  },
  computed: {},
  methods: {
    add: function() {
      let self = this;
      let data = {
        url: self.url + "villages/add/",
        data: self.villageData,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          if (data.villages) {
            self.newVillageId = data.villages;
            self.info = "Границы поселка успешно добавлены";
          }
        }
      });
    },
    clear: function() {
      this.jsonIn = null;
      this.villageData.village = null;
      this.villageData.district = null;
      this.villageData.region = null;
      this.villageData.geometries = [];
      this.info = null;
    },
    parse: function() {
      let self = this;
      let jsonData = JSON.parse(this.jsonIn).data.exactResult;
      let fullName = jsonData.address.split(", ");
      this.villageData.country = fullName[0];
      this.villageData.region = fullName[1];
      this.villageData.district = fullName[2];
      this.villageData.village = fullName[3];
      this.coordsCenter = [jsonData.coordinates[1], jsonData.coordinates[0]];
      this.coords = [jsonData.coordinates[1], jsonData.coordinates[0]];
      let geometries = jsonData.displayGeometry.geometries;

      geometries.forEach(function(value) {
        let resultObj = {};
        resultObj.type = value.type;
        resultObj.coordsCenter = self.coordsCenter;
        resultObj.coordinates = [];
        resultObj.coordinates.push([]);

        value.coordinates[0].forEach(function(valueCoord) {
          resultObj.coordinates[0].push([valueCoord[1], valueCoord[0]]);
        });
        self.villageData.geometries.push(resultObj);
      });
    },
    getUsers: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "users/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.users = data;
          }
        });
    }
  },
  created() {
    this.getUsers();
  }
};
</script>

<style scoped></style>
